import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2000ea87"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loding"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"margin-left":"10px"} }
const _hoisted_4 = { class: "msgScrollerItem" }
const _hoisted_5 = {
  key: 0,
  class: "itembox"
}
const _hoisted_6 = { class: "itemboxLeft" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "itemMsg" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "adLeftBox" }
const _hoisted_14 = { class: "adRightBox" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "subTitle van-multi-ellipsis--l2" }
const _hoisted_17 = {
  key: 2,
  class: "newMsgAD"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "admsg_con" }
const _hoisted_20 = { style: {"color":"#E3A50F","font-weight":"bold","font-size":"14px"} }
const _hoisted_21 = { class: "ad_list" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  style: {"text-decoration":"underline"}
}
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 3 }
const _hoisted_28 = {
  key: 0,
  class: "animationContent"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  class: "chatFooter",
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_31 = { class: "inputBox" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "bqbox" }
const _hoisted_34 = { class: "chatFooter2" }
const _hoisted_35 = { class: "inputBox" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "bq" }
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = {
  key: 1,
  class: "alretUserBox"
}
const _hoisted_40 = { class: "left" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "name" }
const _hoisted_43 = { class: "sub van-multi-ellipsis--l2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isJoin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", { src: $setup.LoginGif }, null, 8 /* PROPS */, _hoisted_2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('play.lodingtext')), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" :style=\"{paddingTop: `${new_title_h+10}px`}\" "),
    _createElementVNode("div", {
      style: _normalizeStyle({ height: 'calc(' + $setup.props.height + 'px - env(safe-area-inset-bottom))' })
    }, [
      _createVNode($setup["DynamicScroller"], {
        items: $setup.msgList,
        "min-item-size": 30,
        "key-field": "chatmsgno",
        ref: "scrollerRef",
        onResize: _cache[0] || (_cache[0] = ($event: any) => ($setup.scrollToBottom())),
        class: "msgScroller",
        onScroll: $setup.handleScroll
      }, {
        default: _withCtx(({ item, index, active }) => [
          _createVNode($setup["DynamicScrollerItem"], {
            item: item,
            active: active,
            "data-index": index,
            "size-dependencies": [item.content, item.msgtype]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (item.msgtype == 1 || item.msgtype == 6 || item.msgtype == 22)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (item.isadmin == 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: $setup.getLV(item.viplevel),
                              alt: "",
                              class: "userLv"
                            }, null, 8 /* PROPS */, _hoisted_7))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: $setup.roomZb,
                              alt: "",
                              class: "userLv"
                            }, null, 8 /* PROPS */, _hoisted_8)),
                        _createElementVNode("div", {
                          class: "itemMsg-name",
                          style: _normalizeStyle({ color: $setup.getNickNameColor(item.isadmin) })
                        }, _toDisplayString(item.nickname) + ": ", 5 /* TEXT, STYLE */)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (item.msgtype == 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: {"color":"#0D0D0D"},
                              onClick: $setup.clickHandle,
                              innerHTML: $setup.ChatUtils.createHtml(item.content)
                            }, null, 8 /* PROPS */, _hoisted_10))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "conter",
                              innerHTML: $setup.msgurl(item.content)
                            }, null, 8 /* PROPS */, _hoisted_11))
                      ])
                    ]))
                  : (item.msgtype == 1000)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "msgAD",
                        onClick: ($event: any) => ($setup.toAD(item.jumpUrl))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_van_image, {
                            fit: "cover",
                            width: "70",
                            height: "70",
                            src: item.img
                          }, null, 8 /* PROPS */, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.content), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_12))
                    : (item.msgtype == 999 && $setup.newAD && $setup.anchor_announcement)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: "new_title",
                            style: _normalizeStyle({ height: `${$setup.new_title_h}px` })
                          }, [
                            _createElementVNode("img", {
                              src: $setup.zbgg,
                              class: "zbgg",
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_18)
                          ], 4 /* STYLE */),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("p", _hoisted_20, _toDisplayString($setup.anchor_announcement.title), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anchor_announcement.content, (ad_list, index) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                ($setup.ispack_up ? true : index == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                      _createTextVNode(_toDisplayString(ad_list.content) + " ", 1 /* TEXT */),
                                      (ad_list.url && ad_list.is_copy == 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(ad_list.url), 1 /* TEXT */))
                                        : (ad_list.url)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: ad_list.url,
                                              target: "adlist"
                                            }, _toDisplayString(ad_list.url), 9 /* TEXT, PROPS */, _hoisted_24))
                                          : _createCommentVNode("v-if", true),
                                      (ad_list.url && ad_list.is_copy == 1)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 2,
                                            src: $setup.copy_id,
                                            class: "copyBtn",
                                            onClick: ($event: any) => ($setup.copyclass('copyBtn', ad_list.url))
                                          }, null, 8 /* PROPS */, _hoisted_25))
                                        : _createCommentVNode("v-if", true),
                                      (ad_list.uid && ad_list.uid !== '')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            class: "ad_kefu_btn",
                                            onClick: ($event: any) => ($setup.onMsgChatClick(ad_list.uid)),
                                            style: _normalizeStyle(`background-color: ${$setup.mainColor}`)
                                          }, _toDisplayString($setup.t('play.chatHost')), 13 /* TEXT, STYLE, PROPS */, _hoisted_26))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]),
                          _createCommentVNode(" <div class=\"pack_up\" @click=\"tapPackup\">\n            <img v-if=\"ispack_up\" :src=\"sq\" alt=\"\">\n            <img v-else :src=\"dk\" alt=\"\">\n          </div> ")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('home.unkowntype') + item.msgtype), 1 /* TEXT */))
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "active", "data-index", "size-dependencies"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["items"])
    ], 4 /* STYLE */),
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($setup.showAnimation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("img", { src: $setup.welcome_icon }, null, 8 /* PROPS */, _hoisted_29),
              _createElementVNode("p", {
                style: _normalizeStyle({ backgroundColor: $setup.marqueeColor, color: $setup.marqueeFontColor })
              }, _toDisplayString($setup.joinUser), 5 /* TEXT, STYLE */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_van_field, {
          "update:model-value": $setup.debounce($setup.changeInputType),
          maxlength: $setup.Platform.chatCharactersNum || 100,
          onPasteCapture: _withModifiers($setup.handleFalse, ["prevent"]),
          onCopyCapture: _withModifiers($setup.handleFalse, ["prevent"]),
          onCutCapture: _withModifiers($setup.handleFalse, ["prevent"]),
          modelValue: $setup.inputValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputValue) = $event)),
          placeholder: $setup.t('play.chatText'),
          style: {"background-color":"rgba(0, 0, 0, 0)"}
        }, null, 8 /* PROPS */, ["update:model-value", "maxlength", "onPasteCapture", "onCopyCapture", "onCutCapture", "modelValue", "placeholder"]),
        _createElementVNode("img", {
          src: $setup.biaoqing,
          class: "biaoqing",
          onClick: $setup.openBiaoqing
        }, null, 8 /* PROPS */, _hoisted_32)
      ]),
      _createCommentVNode(" <img :src=\"sendZbMsg\" alt=\"\" class=\"sendZbMsg\" /> "),
      _createCommentVNode(" <img :src=\"sendBtn\" alt=\"\" @click=\"sendMsg\" class=\"sendBtn\" /> "),
      _createVNode(_component_van_button, {
        round: "",
        plain: "",
        style: {"background-color":"#00DF3A","color":"white","font-size":"12px","font-weight":"600","width":"56px","height":"33px","margin-right":"15px"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isYk && $setup.web_pm_tips ? $setup.nativeToLogin($setup.router, true) :$setup.sendMsg()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('发送')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createCommentVNode(" 弹出的表情选择 "),
    _createVNode(_component_van_action_sheet, {
      show: $setup.showShare,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.showShare) = $event)),
      round: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_van_field, {
                "update:model-value": $setup.debounce($setup.changeInputType),
                onPasteCapture: _withModifiers($setup.handleFalse, ["prevent"]),
                onCopyCapture: _withModifiers($setup.handleFalse, ["prevent"]),
                onCutCapture: _withModifiers($setup.handleFalse, ["prevent"]),
                modelValue: $setup.inputValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.inputValue) = $event)),
                placeholder: $setup.t('play.chatText'),
                style: {"background-color":"rgba(0, 0, 0, 0)"}
              }, null, 8 /* PROPS */, ["update:model-value", "onPasteCapture", "onCopyCapture", "onCutCapture", "modelValue", "placeholder"]),
              _createElementVNode("img", {
                src: $setup.biaoqing,
                class: "biaoqing",
                onClick: $setup.openBiaoqing
              }, null, 8 /* PROPS */, _hoisted_36)
            ]),
            _createCommentVNode(" <img :src=\"sendZbMsg\" alt=\"\" class=\"sendZbMsg\" /> "),
            _createCommentVNode(" <img :src=\"sendBtn\" alt=\"\" @click=\"sendMsg\" class=\"sendBtn\" /> "),
            _createVNode(_component_van_button, {
              round: "",
              plain: "",
              style: {"background-color":"#00DF3A","color":"white","font-size":"12px","font-weight":"600","width":"56px","height":"33px","margin-right":"15px"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.isYk && $setup.web_pm_tips ? $setup.nativeToLogin($setup.router, true) :$setup.sendMsg()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('发送')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createCommentVNode(" 表情区域 "),
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bqSwpierList, (item) => {
              return (_openBlock(), _createElementBlock("img", {
                src: item.img,
                key: item.name,
                class: "bqitem",
                onClick: ($event: any) => ($setup.selBq(item.name))
              }, null, 8 /* PROPS */, _hoisted_38))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    ($setup.showAlertUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_van_image, {
              class: "img",
              fit: "cover",
              src: $setup.alertUserData.a,
              round: ""
            }, null, 8 /* PROPS */, ["src"]),
            _createVNode(_component_van_image, {
              class: "zb",
              src: $setup.roomZb,
              round: ""
            }, null, 8 /* PROPS */, ["src"])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, _toDisplayString($setup.alertUserData.n), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_43, _toDisplayString($setup.alertUserData.t), 1 /* TEXT */)
          ]),
          _createElementVNode("div", {
            class: "start",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.toStart()))
          }, "+ " + _toDisplayString(_ctx.$t('home.onFocus')), 1 /* TEXT */),
          _createVNode(_component_van_icon, {
            name: "clear",
            class: "icon",
            color: "#666",
            onClick: _cache[7] || (_cache[7] = () => $setup.showAlertUser = false)
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}